var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "main-content", staticStyle: { overflow: "auto" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isPreview,
                  expression: "!isPreview"
                }
              ],
              staticStyle: { width: "fit-content" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                _vm._l(_vm.upBlocks, function(block) {
                  return _c(
                    "div",
                    {
                      key: block.pagePart.pagePartName,
                      ref: block.pagePart.pagePartName,
                      refInFor: true,
                      staticClass: "section",
                      staticStyle: { width: "426px", "margin-right": "5px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "125px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class:
                                "title" + (_vm.readonly ? " not-click" : ""),
                              staticStyle: { width: "100%" }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(block.customLabel || block.sysLabel) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "sort-char",
                                  staticStyle: { float: "right" },
                                  on: {
                                    mousedown: function($event) {
                                      return _vm.onMousedown($event, block)
                                    }
                                  }
                                },
                                [_vm._v("≡")]
                              )
                            ]
                          ),
                          _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Display") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.MainTicket")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.MainTicket"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.SlaveTicket")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.SlaveTicket")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Required") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Alias")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Alias"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("Tool.Setting") }
                              },
                              [_vm._v(_vm._s(_vm.$t("Tool.Setting")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Sort")
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sort")))]
                            )
                          ]),
                          _vm._l(block.uiCustomElementList, function(element) {
                            return _c(
                              "el-form-item",
                              {
                                key: element.pagePartElement.elementName,
                                ref: element.pagePartElement.elementName,
                                refInFor: true
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: element.isRequire ? "blue" : "",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v(_vm._s(element.sysLabel))]
                                ),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      element.isRequire ||
                                      !element.branchIsDisplay
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.onDisplayChange(block, element)
                                    }
                                  },
                                  model: {
                                    value: element.isDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "isDisplay", $$v)
                                    },
                                    expression: "element.isDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      element.isRequire ||
                                      !element.branchMasterIsDisplay
                                  },
                                  model: {
                                    value: element.masterIsDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "masterIsDisplay", $$v)
                                    },
                                    expression: "element.masterIsDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      element.isRequire ||
                                      !element.branchSlaveIdDisplay
                                  },
                                  model: {
                                    value: element.slaveIdDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "slaveIdDisplay", $$v)
                                    },
                                    expression: "element.slaveIdDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: { disabled: "" },
                                  model: {
                                    value: element.isRequire,
                                    callback: function($$v) {
                                      _vm.$set(element, "isRequire", $$v)
                                    },
                                    expression: "element.isRequire"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "element-column-text",
                                    staticStyle: {
                                      width: "80px",
                                      "pointer-events": "auto"
                                    },
                                    attrs: { title: element.customLabel }
                                  },
                                  [_vm._v(_vm._s(element.customLabel))]
                                ),
                                [
                                  _vm.canSettingElementNames.includes(
                                    element.pagePartElement.elementName
                                  )
                                    ? [
                                        _vm.readonly
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "element-column-content"
                                              },
                                              [
                                                element.userCustomContent
                                                  ? _c("div", {
                                                      staticClass: "look-blue",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showElementSettingDialog(
                                                            element
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _c("div", {
                                                      staticClass: "look-gray"
                                                    })
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "element-column-content"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-edit",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showElementSettingDialog(
                                                        element
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    : _c("span", {
                                        staticClass: "element-column-content"
                                      })
                                ],
                                element.pagePartElement.elementName !== "jobNo"
                                  ? _c(
                                      "span",
                                      {
                                        class:
                                          "element-column-content sort-char" +
                                          (_vm.readonly ? " not-click" : ""),
                                        staticStyle: { "line-height": "unset" },
                                        on: {
                                          mousedown: function($event) {
                                            return _vm.onMousedown(
                                              $event,
                                              block,
                                              element
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("≡")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm.downBlock
                ? _c(
                    "div",
                    {
                      ref: _vm.downBlock.pagePart.pagePartName,
                      staticClass: "section",
                      staticStyle: { width: "426px" }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-width": "125px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class:
                                "title" + (_vm.readonly ? " not-click" : ""),
                              staticStyle: { width: "100%" }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.downBlock.customLabel ||
                                      _vm.downBlock.sysLabel
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "sort-char",
                                  staticStyle: { float: "right" },
                                  on: {
                                    mousedown: function($event) {
                                      return _vm.onMousedown(
                                        $event,
                                        _vm.downBlock
                                      )
                                    }
                                  }
                                },
                                [_vm._v("≡")]
                              )
                            ]
                          ),
                          _c("el-form-item", { attrs: { label: " " } }, [
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Display") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.MainTicket")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.MainTicket"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.SlaveTicket")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.SlaveTicket")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("SeaExport.Required") }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                staticStyle: { width: "80px" },
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Alias")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Alias"))
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: { title: _vm.$t("Tool.Setting") }
                              },
                              [_vm._v(_vm._s(_vm.$t("Tool.Setting")))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "element-column-text",
                                attrs: {
                                  title: _vm.$t("SystemMaintenance.Sort")
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sort")))]
                            )
                          ]),
                          _vm._l(_vm.downBlock.uiCustomElementList, function(
                            element
                          ) {
                            return _c(
                              "el-form-item",
                              {
                                key: element.pagePartElement.elementName,
                                ref: element.pagePartElement.elementName,
                                refInFor: true
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: element.isRequire ? "blue" : "",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [_vm._v(_vm._s(element.sysLabel))]
                                ),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      element.isRequire ||
                                      !element.branchIsDisplay
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.onDisplayChange(
                                        _vm.downBlock,
                                        element
                                      )
                                    }
                                  },
                                  model: {
                                    value: element.isDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "isDisplay", $$v)
                                    },
                                    expression: "element.isDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      element.isRequire ||
                                      !element.branchMasterIsDisplay
                                  },
                                  model: {
                                    value: element.masterIsDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "masterIsDisplay", $$v)
                                    },
                                    expression: "element.masterIsDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: {
                                    disabled:
                                      _vm.readonly ||
                                      element.isRequire ||
                                      !element.branchSlaveIdDisplay
                                  },
                                  model: {
                                    value: element.slaveIdDisplay,
                                    callback: function($$v) {
                                      _vm.$set(element, "slaveIdDisplay", $$v)
                                    },
                                    expression: "element.slaveIdDisplay"
                                  }
                                }),
                                _c("el-checkbox", {
                                  staticClass: "element-column-content",
                                  attrs: { disabled: "" },
                                  model: {
                                    value: element.isRequire,
                                    callback: function($$v) {
                                      _vm.$set(element, "isRequire", $$v)
                                    },
                                    expression: "element.isRequire"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "element-column-text",
                                    staticStyle: {
                                      width: "80px",
                                      "pointer-events": "auto"
                                    },
                                    attrs: { title: element.customLabel }
                                  },
                                  [_vm._v(_vm._s(element.customLabel))]
                                ),
                                [
                                  _vm.canSettingElementNames.includes(
                                    element.pagePartElement.elementName
                                  )
                                    ? [
                                        _vm.readonly
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "element-column-content"
                                              },
                                              [
                                                element.userCustomContent
                                                  ? _c("div", {
                                                      staticClass: "look-blue",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.showElementSettingDialog(
                                                            element
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _c("div", {
                                                      staticClass: "look-gray"
                                                    })
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "element-column-content"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-edit",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showElementSettingDialog(
                                                        element
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    : _c("span", {
                                        staticClass: "element-column-content"
                                      })
                                ],
                                _c(
                                  "span",
                                  {
                                    class:
                                      "element-column-content sort-char" +
                                      (_vm.readonly ? " not-click" : ""),
                                    staticStyle: { "line-height": "unset" },
                                    on: {
                                      mousedown: function($event) {
                                        return _vm.onMousedown(
                                          $event,
                                          _vm.downBlock,
                                          element
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("≡")]
                                )
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._l(_vm.blocks, function(block) {
            return _c(
              "div",
              {
                key: block.pagePart.pagePartName,
                ref: "drag" + block.pagePart.pagePartName,
                refInFor: true,
                staticClass: "section",
                staticStyle: {
                  width: "426px",
                  height: "0",
                  overflow: "hidden",
                  padding: "0",
                  "margin-bottom": "0"
                }
              },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "125px", "label-position": "right" }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "title", staticStyle: { width: "100%" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(block.customLabel || block.sysLabel) +
                            " "
                        ),
                        _c("i", {
                          staticClass: "el-icon-edit",
                          staticStyle: { "margin-left": "5px" }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "sort-char",
                            staticStyle: { float: "right" }
                          },
                          [_vm._v("≡")]
                        )
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: " " } }, [
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          attrs: { title: _vm.$t("SeaExport.Display") }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Display")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          attrs: {
                            title: _vm.$t("SystemMaintenance.MainTicket")
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.MainTicket")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          attrs: {
                            title: _vm.$t("SystemMaintenance.SlaveTicket")
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SlaveTicket"))
                          )
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          attrs: { title: _vm.$t("SeaExport.Required") }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Required")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          staticStyle: { width: "80px" },
                          attrs: { title: _vm.$t("SystemMaintenance.Alias") }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Alias")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          attrs: { title: _vm.$t("Tool.Setting") }
                        },
                        [_vm._v(_vm._s(_vm.$t("Tool.Setting")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "element-column-text",
                          attrs: { title: _vm.$t("SystemMaintenance.Sort") }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Sort")))]
                      )
                    ]),
                    _vm._l(block.uiCustomElementList, function(element) {
                      return _c(
                        "el-form-item",
                        {
                          key: element.pagePartElement.elementName,
                          ref: "drag" + element.pagePartElement.elementName,
                          refInFor: true,
                          staticStyle: { "background-color": "#f0f3f8" }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: element.isRequire ? "blue" : "",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(element.sysLabel))]
                          ),
                          _c("el-checkbox", {
                            staticClass: "element-column-content",
                            model: {
                              value: element.isDisplay,
                              callback: function($$v) {
                                _vm.$set(element, "isDisplay", $$v)
                              },
                              expression: "element.isDisplay"
                            }
                          }),
                          _c("el-checkbox", {
                            staticClass: "element-column-content",
                            model: {
                              value: element.masterIsDisplay,
                              callback: function($$v) {
                                _vm.$set(element, "masterIsDisplay", $$v)
                              },
                              expression: "element.masterIsDisplay"
                            }
                          }),
                          _c("el-checkbox", {
                            staticClass: "element-column-content",
                            model: {
                              value: element.slaveIdDisplay,
                              callback: function($$v) {
                                _vm.$set(element, "slaveIdDisplay", $$v)
                              },
                              expression: "element.slaveIdDisplay"
                            }
                          }),
                          _c("el-checkbox", {
                            staticClass: "element-column-content",
                            model: {
                              value: element.isRequire,
                              callback: function($$v) {
                                _vm.$set(element, "isRequire", $$v)
                              },
                              expression: "element.isRequire"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticClass: "element-column-text",
                              staticStyle: { width: "80px" },
                              attrs: { title: element.customLabel }
                            },
                            [_vm._v(_vm._s(element.customLabel))]
                          ),
                          [
                            _vm.canSettingElementNames.includes(
                              element.pagePartElement.elementName
                            )
                              ? _c(
                                  "span",
                                  { staticClass: "element-column-content" },
                                  [_c("i", { staticClass: "el-icon-edit" })]
                                )
                              : _c("span", {
                                  staticClass: "element-column-content"
                                })
                          ],
                          _c(
                            "span",
                            {
                              staticClass: "element-column-content sort-char",
                              staticStyle: { "line-height": "unset" }
                            },
                            [_vm._v("≡")]
                          )
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              ],
              1
            )
          }),
          _vm.isPreview
            ? _c("tab-booking-FCLUICustom", {
                attrs: {
                  context: _vm.bookingWorkspaceContext,
                  action: "look",
                  "preview-config": _vm.previewConfig
                }
              })
            : _vm._e()
        ],
        2
      ),
      _c("element-set-dialog", {
        attrs: {
          visible: _vm.elementSetDialog.visible,
          element: _vm.elementSetDialog.element,
          "is-edit": _vm.isEdit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.elementSetDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }